<template lang="html">
  <div></div>
</template>

<script>
export default {
  created() {
    window.location.href = this.$constants.urls.helpCenter
  },
}
</script>
